var _defs, _rect, _rect2, _path, _path2, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCertificateVault({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 240,
    viewBox: "0 0 400 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "vaultBg",
    x1: 0,
    y1: 0,
    x2: 400,
    y2: 240,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0f172a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1e293b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "goldGrad",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fbbf24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f59e0b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "blueGrad",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3b82f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6366f1"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 240,
    rx: 12,
    fill: "url(#vaultBg)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 399,
    height: 239,
    rx: 11.5,
    stroke: "#334155",
    strokeOpacity: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 60 H400 M0 120 H400 M0 180 H400",
    stroke: "#334155",
    strokeOpacity: 0.15,
    strokeDasharray: "4 4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M100 0 V240 M200 0 V240 M300 0 V240",
    stroke: "#334155",
    strokeOpacity: 0.15,
    strokeDasharray: "4 4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(130, 30)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 10,
    width: 120,
    height: 150,
    rx: 8,
    fill: "#090d16",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 140,
    height: 165,
    rx: 8,
    fill: "#1e293b",
    stroke: "#3b82f6",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 128,
    height: 153,
    rx: 5,
    fill: "none",
    stroke: "#475569",
    strokeWidth: 1,
    strokeDasharray: "3 3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 42,
    r: 18,
    fill: "url(#goldGrad)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63 56 L58 72 L70 66 L82 72 L77 56 Z",
    fill: "url(#goldGrad)",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70 34 L72.5 39.5 L78 40 L74 43.5 L75 49 L70 46 L65 49 L66 43.5 L62 40 L67.5 39.5 Z",
    fill: "#78350f"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 80,
    width: 90,
    height: 6,
    rx: 3,
    fill: "#94a3b8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 94,
    width: 70,
    height: 4,
    rx: 2,
    fill: "#64748b"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 108,
    width: 100,
    height: 4,
    rx: 2,
    fill: "#475569"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 25,
    y1: 135,
    x2: 65,
    y2: 135,
    stroke: "#60a5fa",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 105,
    cy: 132,
    r: 10,
    fill: "url(#blueGrad)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101 132 L104 135 L110 128",
    stroke: "#ffffff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(135, 205)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 130,
    height: 24,
    rx: 12,
    fill: "#065f46",
    fillOpacity: 0.4,
    stroke: "#10b981",
    strokeOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 12,
    r: 4,
    fill: "#10b981"
  }), /*#__PURE__*/React.createElement("text", {
    x: 26,
    y: 16,
    fill: "#34d399",
    fontFamily: "-apple-system, sans-serif",
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: "0.05em"
  }, "VERIFIED REPOSITORY"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificateVault);
export default __webpack_public_path__ + "static/media/certificate_vault.b296b1fcbcaeaf5decd9196ca8d50bff.svg";
export { ForwardRef as ReactComponent };